export const useSeatsDisplay = () => {
  const showIncludedSeats = true;
  const showAdditionalSeatsPriceSubtext = true;
  const additionalCoreSeatsPrice = 50;
  return {
    showIncludedSeats,
    showAdditionalSeatsPriceSubtext,
    additionalCoreSeatsPrice
  };
};